import {CommonModule, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import {finalize, tap} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientDto} from "../../../_models/client.dtos";
import {ClientsService} from "../../../../services/client-service/clients.service";
import { SidebarComponent } from '../../../../common/sidebar/sidebar.component';

@Component({
    selector: 'app-client-list',
    standalone: true,
    providers: [ApiService, Endpoints, DialogService, ClientsService],
    imports: [
        MatCardModule,CommonModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf
    ],
    templateUrl: './client-list.component.html',
    styleUrl: './client-list.component.scss'
})
export class ClientListComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() clients: any[] = []
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    dataSource = new MatTableDataSource<ClientDto>();
    searchValue: string = ''
    loadingTable: boolean = true;
            
    displayedColumns: string[] = ['identification', 'socialReason', 'headQuarter','activityField','ice','address','billingAddress','status', 'notes', 'action'];
    constructor(
        private apiService: ApiService,
        private clientService: ClientsService,
        private endpoints: Endpoints,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        public themeService: CustomizerSettingsService,
        private handleError: HandleErrorsService,) {
        this.initializeEditForm();
        this.initializeCreateForm()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['dataSource']){
            console.log('datasource changed')
            console.log('..'.repeat(40))
        }
    }

    ngOnInit(): void {
            this.fetchClientList()
    }
    openViewModel(sample: ClientDto) {
        this.form.patchValue(sample);
        this.cdr.detectChanges();
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
    }

    fetchClientList() {
        this.clientService.loadClients().subscribe({
            next: (response: any) => {
                if (response.status) {
                    this.dataSource.data = response.data
                    this.loadingTable = false
                }
            },
            error: err => {
                this.handleError.catchError(err)
                this.loadingTable = false
            }
        });
    }

    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'})
    }

saveClient(): void {
    console.log('Début de saveClient');

    console.log('État du formulaire:', this.form);
    console.log('Erreurs:', this.form.errors);
    console.log('Erreurs des contrôles:', Object.keys(this.form.controls).map(key => ({
      key,
      errors: this.form.controls[key].errors
    })));

    if (this.form.valid) {
        console.log('Formulaire valide, données à sauvegarder:', this.form.value);

        this.clientService.handleSave(this.form.value).subscribe({
            next: res => {
                console.log('Réponse reçue du service save:', res);
                if (res.status) {
                    console.log('Ajout réussi, ajout du client à dataSource:', res.data);
                    this.dataSource.data = [...this.dataSource.data, res.data];
                    this.form.reset();
                } else {
                    console.warn('Ajout échoué, status false');
                }
            },
            error: err => {
                console.error('Erreur lors de l\'ajout du client:', err);
                this.handleError.catchError(err);
            },
            complete: () => {
                console.log('Ajout terminé, fermeture modal et notification');
                this.modalService.dismissAll();
                this.dialogService.openSuccessDialog('Le client a été ajouté avec succès.');
            }
        });
    } else {
        console.warn('Formulaire invalide');
        this.dialogService.openDangerAlert('Erreur de saisie. Merci de vérifier les informations saisies.');
        this.form.markAllAsTouched();
    }
}


    initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
    }
    ngAfterViewInit() {
        this.initializePaginatorAndSort();
        const overlayContainerElement = this.overlayContainer.getContainerElement();
        overlayContainerElement.style.zIndex
            = '2000';
    }
    initializeEditForm() {
        this.editForm = this.fb.group({
            id: [''],
            identification: ['', Validators.required],
            socialReason: ['', Validators.required],
            headQuarter: [''],
            
            phone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            fax: ['', [Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            mail: ['', [Validators.required, Validators.email]],
            activityField: [''],
            ice: ['', [Validators.required,Validators.pattern('^[0-9]*$')]],
            billingAddress: [''],
            address: ['', Validators.required],
            flag: ['', Validators.required],
            note: [''],
        });
    }

    initializeCreateForm() {
        this.form = this.fb.group({
            identification: ['', Validators.required],
            socialReason: ['', Validators.required],
            headQuarter: [''],
            
            phone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            fax: ['', [ Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            mail: ['', [Validators.required, Validators.email]],
            activityField: [''],
            ice: ['', [Validators.required,Validators.pattern('^[0-9]*$')]],
            address: ['', Validators.required],
            billingAddress: ['', Validators.required],
            flag: [1, Validators.required],
            note: [''],
        });
    }

    openEditModal(element: any) {
        console.log("element",element)
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

updateClient() {
    console.log('Début de updateClient');
    if (this.editForm.valid) {
        const oldClient: ClientDto = this.editForm.value;
        console.log('Formulaire valide, client à mettre à jour:', oldClient);

        this.clientService.handleUpDate(oldClient).subscribe({
            next: res => {
                console.log('Réponse reçue du service update:', res);
                if (res.status) {
                    const index = this.dataSource.data.findIndex(cl => cl.id == oldClient.id);
                    console.log(`Client trouvé à l'index ${index}, mise à jour des données`);
                    this.dataSource.data[index] = res.data;
                } else {
                    console.warn('Mise à jour échouée, status false');
                }
            },
            error: err => {
                console.error('Erreur lors de la mise à jour du client:', err);
                this.handleError.catchError(err);
            },
            complete: () => {
                console.log('Mise à jour terminée, fermeture modal et notification');
                this.modalService.dismissAll();
                this.dialogService.openSuccessDialog('Client modifié avec succés.');
                this.initializePaginatorAndSort();
            }
        });

    } else {
        console.warn('Formulaire invalide');
        this.dialogService.openDangerAlert('Erreur de saisie. Merci de vérifier les informations saisies.');
    }
}

    confirmDelete(element: any) {
        this.dialogService.open('Êtes-vous sûr de vouloir supprimer ce client?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteClient(element.id);
                }
            });
    }

    deleteClient(id: number) {
        this.apiService.delete(id, this.endpoints.client_base_endpoint).pipe(
            tap((response: any) => {
                if (response.status) {
                    this.removeTableRow(id);
                    this.dialogService.openSuceessAlert("Client supprimé avec succès");
                }
            }),
            finalize(() => {
                this.dataSource.paginator = this.paginator;
            })
        ).subscribe();
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }



}
